import React, { useState } from 'react';
import classNames from 'classnames';

const ExpandablePanel = ({ label, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(!isOpen);

  return (
    <div className="c-support-place__filter-expand">
      <button
        aria-controls="filter-expand-collapse"
        aria-expanded={isOpen}
        className={classNames({
          'c-support-place__filter-expand__header': true,
          'c-support-place__filter-expand__header--is-open': isOpen,
        })}
        onClick={handleToggle}
        type="button"
      >
        <span>{label}</span>
        <div
          aria-hidden
          className={classNames({
            'c-support-place__filter-expand__chevron': true,
            'c-support-place__filter-expand__chevron--is-expanded': isOpen,
          })}
        />
      </button>
      <div
        aria-hidden
        id="filter-expand"
        className={classNames({
          'c-support-place__filter-expand__content': true,
          'c-support-place__filter-expand__content--is-open': isOpen,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default ExpandablePanel;
